import { render, staticRenderFns } from "./MarkComboJudge.vue?vue&type=template&id=268546f8&scoped=true&"
import script from "./MarkComboJudge.vue?vue&type=script&lang=js&"
export * from "./MarkComboJudge.vue?vue&type=script&lang=js&"
import style0 from "./MarkComboJudge.vue?vue&type=style&index=0&id=268546f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268546f8",
  null
  
)

export default component.exports